import { createSlice } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit'
import { English } from '../languages/en'
import { French } from '../languages/fr'
import { RootState } from '../store'
const detectBrowserLanguage = require('detect-browser-language')

/** Lazy language packs — keep en/fr eager (most traffic); code-split the rest. */
const lazyPacks: Record<string, () => Promise<any>> = {
  de: () => import('../languages/de').then((m) => m.German),
  es: () => import('../languages/es').then((m) => m.Spain),
  ar: () => import('../languages/ar').then((m) => m.Arabic),
  pt: () => import('../languages/pt').then((m) => m.Potugues),
}

const packCache: Record<string, any> = {
  en: English,
  fr: French,
}

const deteclanguage = detectBrowserLanguage()
let defaultLanguage = "en"
let Init_Languagemodel = English
if (deteclanguage.search("en") >= 0) {
  defaultLanguage = "en"
} else if (deteclanguage.search("fr") >= 0) {
  defaultLanguage = "fr"
  Init_Languagemodel = French
} else if (deteclanguage.search("de") >= 0) {
  defaultLanguage = "de"
} else if (deteclanguage.search("es") >= 0) {
  defaultLanguage = "es"
} else if (deteclanguage.search("pt") >= 0) {
  defaultLanguage = "pt"
} else if (deteclanguage.search("ar") >= 0) {
  defaultLanguage = "ar"
}

export interface translateState {
  mode: any,
  languagemodel: any
}

const initialState: translateState = {
  mode: defaultLanguage,
  languagemodel: Init_Languagemodel,
}

function syncPack(code: string) {
  if (code === "en") return English
  if (code === "fr") return French
  return packCache[code] || English
}

export const translateSlice = createSlice({
  name: 'translate',
  initialState,
  reducers: {
    Translatechangemode: (state, action: PayloadAction<string>) => {
      state.mode = action.payload
      state.languagemodel = syncPack(action.payload)
    },
    TranslateSetPack: (state, action: PayloadAction<{ mode: string; pack: any }>) => {
      const { mode, pack } = action.payload
      packCache[mode] = pack
      if (state.mode === mode) {
        state.languagemodel = pack
      }
    },
  },
})

export async function loadLanguagePack(mode: string) {
  if (packCache[mode]) return packCache[mode]
  const loader = lazyPacks[mode]
  if (!loader) return English
  const pack = await loader()
  packCache[mode] = pack
  return pack
}

// Action creators are generated for each case reducer function
export const { Translatechangemode, TranslateSetPack } = translateSlice.actions

export const Languagemodel = (state: RootState) => state.translate.languagemodel

export default translateSlice.reducer
